import React from 'react';
import { Alert } from '@ver-uds/uswds-react';
import { Link } from 'react-router-dom';
import { EveRoutes } from '@ver-uds/e-verify';
import { useEnrollment } from '../../../context/Enrollment/EnrollmentContext';
import { useMouDocumentQuery } from '../../../services/AccountApi';
import AuthFileLink from '../../AuthFileLink';

const ClientEnrollmentPending = (): JSX.Element => {
  const { completedEnrollment } = useEnrollment();
  const companyName = completedEnrollment?.companyInfo?.companyName || 'account';
  const clientAccountId = completedEnrollment?.id;

  return (
    <div className="tablet:grid-col-12 desktop:grid-col-9" data-testid="enrollment-pending-context">
      <h1>Completing the Enrollment Process</h1>
      <p className="margin-y-3">
        Congratulations on submitting your client’s enrollment
        {completedEnrollment?.companyInfo?.companyName && clientAccountId ? (
          <>
            {' '}
            for{' '}
            <b>
              {completedEnrollment?.companyInfo.companyName} (Company ID: {clientAccountId})
            </b>
          </>
        ) : (
          ''
        )}
        ! Before you can create cases on behalf of your client, they will need to sign the Memorandum of Understanding
        (MOU).
      </p>
      <Alert className="margin-y-3" status="info" slim>
        <Alert.Text>
          An email was sent to the Signatory that you added during enrollment. The Signatory will be able to
          electronically sign the MOU once they receive the email. You will be notified by email once the client accepts
          the MOU.
        </Alert.Text>
      </Alert>
      <p className="margin-y-3">
        REMINDER: You must print and provide each of your clients with the English and Spanish versions of the E-Verify
        Participation poster and the Right to Work poster. These posters are available from the{' '}
        <a href={EveRoutes.RESOURCES_VIEW}>Resources</a> section. Your client(s) must display the posters in plain view
        at their hiring site(s) to inform prospective employees that their company is participating in E-Verify.
      </p>
      {clientAccountId && (
        <AuthFileLink
          linkText="View Memorandum of Understanding"
          query={useMouDocumentQuery}
          queryArg={clientAccountId}
          aria-label={`View Memorandum of Understanding for ${companyName} in a new tab`}
          className="usa-button usa-button--outline"
        />
      )}
      <Link className="usa-button usa-button--primary" to={EveRoutes.COMPANY_CLIENTS_VIEW}>
        Manage Clients
      </Link>
    </div>
  );
};

export default ClientEnrollmentPending;
